import React from "react";

export const About = () => {
  return (
    <section 
      className="om-oss" 
      style={{ padding: "20px", fontFamily: "Arial, sans-serif", color: "#333", textAlign: "center" }}
    >
      <h2 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#004d66" }}>Om oss</h2>

      <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "20px" }}>
        Vi är ert lokala expertföretag inom metallbearbetning, baserat i Varekil på vackra Orust. Med över 20 års gedigen erfarenhet inom <strong>konstruktion, svetsning och pulverlackering</strong>, har vi den kunskap och kapacitet som krävs för att förverkliga era projekt – stora som små.
      </p>

      <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "20px" }}>
        Vi erbjuder helhetslösningar anpassade efter just era behov och önskemål. Vår process sträcker sig ofta hela vägen från <strong>idé, design och konstruktion till tillverkning, reparation och slutlig ytbehandling</strong> genom blästring och högkvalitativ pulverlackering.
      </p>

      <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "20px" }}>
        Eftersom vi utför de flesta moment i vår egen välutrustade verkstad, kan vi säkerställa en <strong>effektiv och kostnadseffektiv process</strong> utan att tumma på kvaliteten. Vi strävar alltid efter att leverera förstklassigt hantverk som håller.
      </p>

      <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "20px" }}>
        Genom åren har vi haft förmånen att arbeta med en bred kundkrets, <strong>bland andra Postnord, Volvo, Försvarsmakten och Wallhamn AB</strong>, samt många lokala småföretagare och privatpersoner på Orust med omnejd.
      </p>

      <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "20px", fontWeight: "bold" }}>
        Har du ett projekt i åtanke? Kom in till oss i Varekil eller hör av dig, så kan vi diskutera hur vi bäst kan hjälpa just dig!
      </p>
    </section>
  );
};
